<div class="profile-container">
    <h2 i18n>My Profile</h2>
    <mat-grid-list [cols]="totalCols" rowHeight="90px" (window:resize)="onResize($event)">
        <mat-grid-tile [colspan]="addressCols" [rowspan]="addressRows">
            <app-profile-form class="h100"></app-profile-form>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="newsletterCols" [rowspan]="newsletterRows">
            <mat-card class="card newsletter-card">
                <mat-card-content>
                    <p i18n  class="mat-card-header">NEWSLETTER</p>
                    <div class="newsletter">
                        <div style="display: flex; flex-direction: column;">
                            <p i18n  class="title">Sign up for our newsletter!</p>
                            <p i18n  class="text-2">Yes, I would like to subscribe to the Ancytree newsletter and receve information about news and exclusive offers.</p>
                        </div>
                        <div class="sub-form" style="margin-top: 25px;">
                            <button i18n class="subscribe" (click)="newsletter(!profileForm.value.newsletter)" *ngIf="!profileForm.value.newsletter">Subscribe</button>
                            <button i18n class="subscribe" (click)="newsletter(!profileForm.value.newsletter)" *ngIf="profileForm.value.newsletter">Unsubscribe</button>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="otherCols" [rowspan]="otherRows">
            <mat-card class="card other-card">
                <mat-card-content>  
                    <mat-card-content *ngIf="organization.name.length >= 1">
                        <p i18n  class="mat-card-header">COLLABORATION PARTNER/ORGANIZATION</p>
                        <div class="detail">
                            <p class="text-1"><span i18n class="title">Partner: </span> {{organization.name}}</p>
                            <p i18n  class="text-2"><span class="title">Current Offer: </span>{{discount.procentage * 100}}% discount on all your orders</p>
                        </div>
                    </mat-card-content>
                    <p i18n  class="mat-card-header">CUSTOMER ADDRESS</p>
                    <!-- <p i18n  class="mat-card-header">SETTINGS</p> -->
                    <div class="detail">
                        <p i18n  class="title">Account details</p>
                        <form>
                            <div class="item">
                                <label i18n for="email">Change Password For</label>
                                <input type="text" id="email" [value]="useremail" disabled>
                            </div>
                        </form>
                        <div class="btn-group">
                            <!-- <button i18n>Edit Account Details</button> -->
                            <button i18n (click)="resetPassword()">Change Password</button>
                        </div>
                        <form>
                            <div class="item">
                                <label i18n for="email">Change Email Address</label>
                                <input type="text" id="changeEmail" #emailInput="ngModel" 
                                [(ngModel)]="changeEmail" name="email" required
                                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}">
                                <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
                                    <div i18n *ngIf="emailInput.errors.required">
                                        Email is required.
                                    </div>
                                    <div i18n *ngIf="emailInput.errors.pattern">
                                        Please enter a valid email address.
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="btn-group">
                            <button i18n (click)="updateEmail(changeEmail)" [disabled]="emailInput.invalid">Change Email</button>
                        </div>
                        <div class="delete">
                            <p i18n  class="text-1">Unhappy?</p>
                            <p i18n  class="text-2">Do you want to delete this account?</p>
                            <button i18n class="delete-btn" (click)="dissableAccount()" href="#">Delete my account</button>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </mat-grid-tile>
    </mat-grid-list>
</div>